import { createNameSpace } from '../utils/NameSpace.js';
import { Prefix } from '../utils/Prefix.js';
export var ns = createNameSpace('https://purl.org/on/lincd/');
export var _self = ns('');
Prefix.add('lincd', _self.uri);
var Module = ns('Module');
var ShapeClass = ns('ShapeClass');
var definesShape = ns('definesShape');
var module = ns('module');
var usesShapeClass = ns('usesShapeClass');
var editInline = ns('editInline');
var isExtending = ns('isExtending');
export var lincd = {
    Module,
    ShapeClass,
    definesShape,
    module,
    usesShapeClass,
    editInline,
    isExtending
};
//# sourceMappingURL=lincd.js.map